import React from 'react'

export default class Footer extends React.Component {
    render() {
        return(
            <footer className="mt-1">
                <p>
                    Created by <a href="https://Caleb335.github.io/Caleb335" target="__blank"> Seven</a>
                </p>
            </footer>
        )
    }
}